import { createModel } from '@rematch/core';
import reducers from './reducers';
import state from './state';
import { type RootModel } from './..';

const filters = createModel<RootModel>()({
  name: 'filters',
  state,
  reducers,
});

export default filters;
